import { MutableRefObject, useEffect, useRef } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'

export const usePropAsRef = <T extends unknown>(prop: T): MutableRefObject<T> => {
    const ref: MutableRefObject<T> = useRef<T>(prop)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        if (isMounted.current) {
            ref.current = prop
        }
    }, [prop])

    return ref
}
